import {observer} from 'mobx-react';
import React from 'react';
import {TreeService} from './models/tree-service';
import {TreeNodeComponent} from './TreeNodeComponent';

@observer
export class TreeComponent extends React.Component<{ tree: TreeService }> {
  render() {
    const tree = this.props.tree;
    const children = tree.root.children;
    return (
      <div className="sidebar-menu">
        {
          children.map(child =>
            (<TreeNodeComponent key={child.data.route} 
                                node={child}/>))
        }
      </div>);
  }
}
